export const SERVICE_CARD_STAGES = [
  ['pre_service_inspection', 'Pre-service'],
  ['job_checklist', 'Service work'],
  ['final_qc', 'Final QC'],
]

function text(value) {
  return String(value || '').trim()
}

export function serviceCardSelectionValue(card = {}) {
  const key = text(card.blueprint_key)
  const version = Number(card.version || 0)
  return key && version > 0 ? `${key}:${version}` : ''
}

export function parseServiceCardSelection(value) {
  const clean = text(value)
  const separator = clean.lastIndexOf(':')
  if (separator < 1) return { blueprintKey: '', version: null }
  const version = Number(clean.slice(separator + 1))
  return {
    blueprintKey: clean.slice(0, separator),
    version: Number.isInteger(version) && version > 0 ? version : null,
  }
}

export function groupServiceCards(cards = []) {
  const groups = new Map()
  cards
    .filter(card => card?.active !== false)
    .sort((a, b) => text(a.family).localeCompare(text(b.family)) || text(a.name).localeCompare(text(b.name)))
    .forEach(card => {
      const family = text(card.family) || 'Other'
      if (!groups.has(family)) groups.set(family, [])
      groups.get(family).push(card)
    })
  return Array.from(groups, ([family, options]) => ({ family, options }))
}

export function activeServiceCardAssignment(assignments = [], serviceId = '') {
  return assignments.find(row => row?.active !== false && String(row?.service_id || '') === String(serviceId || '')) || null
}

export function serviceSetupIssues(service = {}, assignment = null) {
  const issues = []
  if (String(service.module_key || '').toLowerCase() !== 'general') return issues
  if (Number(service.expected_labour_minutes || 0) <= 0) issues.push('Expected labour required')
  if (!assignment?.checklist_template_id) issues.push('Service Card required')
  return issues
}

export function serviceCardPreviewItems(card = {}) {
  const rows = Array.isArray(card.items) ? card.items : []
  return SERVICE_CARD_STAGES.map(([stage, label]) => ({
    stage,
    label,
    items: rows
      .filter(item => item.stage === stage)
      .sort((a, b) => Number(a.display_order || 0) - Number(b.display_order || 0)),
  }))
}
